import type * as React from 'react';
import { View } from 'react-native';

import type * as api from '@gitbook/api-client';

import { ensureStackElements } from './ContentKitStack';
import type { ContentKitElementProps } from './types';

/**
 * Box wrapper in a stack.
 */
export function ContentKitBox(
    props: ContentKitElementProps<api.ContentKitBox>
): React.ReactElement {
    const { element, renderElements } = props;

    const isOnlyInline = element.children.every((child) => child.type === 'text');

    return (
        <View>
            {isOnlyInline
                ? renderElements('inline', element.children)
                : renderElements('block', ensureStackElements('vstack', element.children))}
        </View>
    );
}
